export default __webpack_public_path__ + "static/media/spiritualruin.d28b47e8.png";